import {
  Comment,
  ExpandableSection,
  Username,
} from "@crunchyroll/cx-web-components";
import { FormattedMessage } from "react-intl";
import { getFormattedPublicationDate } from "../helpers/getFormattedPublicationDate";
import { CommentActionsContainer } from "./CommentActionsContainer";
import { useComments } from "../hooks/useComments";

const CommentWrapper = ({ id }) => {
  const { byId } = useComments();
  const {
    authorUsername,
    authorAvatar,
    message,
    isJustPosted,
    isUserOwner,
    isReply,
    createdAt,
  } = byId[id] || {};

  const publicationDate = getFormattedPublicationDate(createdAt);

  return (
    <Comment
      key={id}
      username={<Username>{authorUsername}</Username>}
      avatar={authorAvatar}
      body={
        <ExpandableSection
          text={message}
          collapsedLabel={
            <FormattedMessage id="expandable_section.show_more" />
          }
          expandedLabel={<FormattedMessage id="expandable_section.show_less" />}
        />
      }
      isJustPosted={isJustPosted}
      isAuthor={isUserOwner}
      isReply={isReply}
      publicationDate={publicationDate}
      actions={<CommentActionsContainer id={id} />}
    />
  );
};

export default CommentWrapper;
